// sockets/socketsConnection.jsx
import SockJS from "sockjs-client";
import { environment } from "../environments/environment";
import { Stomp } from "@stomp/stompjs";

let stompClient = null;
let connected = false;
const subscribers = new Map();
let socketURL = environment.socketsConnectionURL
/**
 * Connects to the websocket if not already connected
 */
export function connectSocket(URL = socketURL) {
  return new Promise((resolve, reject) => {
    const socket = new SockJS(URL);
    stompClient = Stomp.over(socket);

    stompClient.connect(
      {},
      () => {
        console.log("[WS] Connected");
        connected = true;
        resolve();
      },
      (err) => {
        console.error("[WS] Error", err);
        connected = false;
        reject(err);
      }
    );
  });
}

export function subscribeSocket(topic, callback) {
  if (!connected) {
    console.warn("[WS] Not connected yet:", topic);
    return;
  }

  stompClient.subscribe(topic, (msg) => {
    callback(JSON.parse(msg.body));
  });
}
/**
 * Send a message to a destination
 */
export function send(destination, body) {
  if (!stompClient || !connected) {
    console.warn("[WS] Cannot send, not connected");
    return;
  }
  stompClient.send(destination, {}, JSON.stringify(body));
}

/**
 * Disconnect the websocket
 */
export function disconnectSocket() {
  if (stompClient && connected) {
    stompClient.disconnect();
    connected = false;
    stompClient = null;
    subscribers.clear();
    console.log("[WS] Disconnected");
  }
}
